module.exports = {
  title: 'ios-home-grid',
  author: 'Enzo Manuel Mangano',
  date: '2025-06-03',
  slug: 'ios-home-grid',
  tags: ['reanimated', 'gesture-handler', 'expo-blur', 'react-navigation'],
};
